export const receipts_MOCK = {
  home: {
    utente: {
      nome: 'Marco Rossi',
      ruolo: 'Agente',
      iniziali: 'MR',
    },
    conteggi: {
      incassiInLavorazione: 12,
      brogliacci: 3,
      distinteVersamento: 2,
    },
  },
  clienti: [
    { id: 'c1', codiceAS400: '0001234567', zona: 'TO-01', clienteRagioneSociale: 'AUTOTRASPORTI ROSSI SRL', clienteCitta: 'TORINO', clienteIndirizzo: 'Via Po 12', partitaIVA: '01234560019', debitoScoperto: 4820.50, debitoScaduto: 1200.00, situazionePartite: 'Scadute' },
    { id: 'c2', codiceAS400: '0007654321', zona: 'TO-01', clienteRagioneSociale: 'BIANCHI CARBURANTI SPA', clienteCitta: 'MONCALIERI', clienteIndirizzo: 'Corso Roma 88', partitaIVA: '09876540017', debitoScoperto: 0, debitoScaduto: null, situazionePartite: 'OK' },
    { id: 'c3', codiceAS400: '0009988776', zona: 'TO-02', clienteRagioneSociale: 'VERDI LOGISTICA SNC', clienteCitta: 'RIVOLI', clienteIndirizzo: 'Via Torino 5', partitaIVA: '05566770010', debitoScoperto: 2310.00, debitoScaduto: null, situazionePartite: 'Scoperto' },
  ],
  incassiInLavorazione: [
    { id: '102762', zona: 'Pozzuoli', cliente: 'C.M.A.R. Ricambi', dataIncasso: '2026-03-18', situazione: 'Lavorazione' },
    { id: '104137', zona: 'Castellammare', cliente: 'F.LLI Amita s.r.l.', dataIncasso: '2026-02-02', situazione: 'Lavorazione' },
    { id: '270016', zona: 'Torino', cliente: 'Autofficina di Mario', dataIncasso: '2026-01-28', situazione: 'Lavorazione' },
    { id: '151763', zona: 'Torino', cliente: 'F.lli Fumagalli snc', dataIncasso: '2026-01-20', situazione: 'Lavorazione' },
    { id: '834530', zona: 'Torino', cliente: 'Carrozzeria San Carlo', dataIncasso: '2026-01-01', situazione: 'Lavorazione' },
    { id: '673211', zona: 'Roma', cliente: 'Azienda Agricola Rossi', dataIncasso: '2025-12-26', situazione: 'Lavorazione' },
    { id: '165079', zona: 'Milano', cliente: 'Ricambi motori snc', dataIncasso: '2025-12-04', situazione: 'Lavorazione' },
    { id: '345356', zona: 'Napoli', cliente: '28/06/2026', dataIncasso: '2025-11-25', situazione: 'Lavorazione' },
    { id: '136825', zona: 'Bologna', cliente: '28/06/2026', dataIncasso: '2025-11-03', situazione: 'Lavorazione' },
    { id: '210883', zona: 'Firenze', cliente: '28/06/2026', dataIncasso: '2025-10-21', situazione: 'Lavorazione' },
    { id: '251007', zona: 'Palermo', cliente: '28/06/2026', dataIncasso: '2025-09-26', situazione: 'Lavorazione' },
    { id: '135355', zona: 'Genova', cliente: '28/06/2026', dataIncasso: '2025-09-09', situazione: 'Lavorazione' },
  ],
  brogliacci: [
    {
      id: 'brg-003',
      numeroBrogliaccio: 'BRG-003',
      data: '2026-03-18',
      importoTotale: 800,
      importoContanti: 800,
      importoAssegni: 0,
      numeroIncassi: 1,
      presaInCarico: '18/03/2026',
      situazione: 'Rendicontato',
    },
    {
      id: 'brg-002',
      numeroBrogliaccio: 'BRG-002',
      data: '2025-03-18',
      importoTotale: 800,
      importoContanti: 800,
      importoAssegni: 0,
      numeroIncassi: 1,
      presaInCarico: '18/03/2025',
      situazione: 'Confermato',
    },
    {
      id: 'brg-001',
      numeroBrogliaccio: 'BRG-001',
      data: '2025-03-20',
      importoTotale: 1450,
      importoContanti: 1450,
      importoAssegni: 0,
      numeroIncassi: 3,
      presaInCarico: '-',
      situazione: 'Aperto',
    },
  ],
  distinteVersamento: [
    {
      id: 'distinta-26492',
      numeroDistinta: '26492',
      dataCreazione: '2025-08-03',
      importoContanti: 2320,
      importoAssegni: 3711.87,
      importoTotale: 6031.87,
      situazione: 'Lavorazione',
    },
    {
      id: 'distinta-6352',
      numeroDistinta: '6352',
      dataCreazione: '2025-11-18',
      importoContanti: 820,
      importoAssegni: 494.68,
      importoTotale: 1314.68,
      situazione: 'Verificata',
    },
    {
      id: 'distinta-7809',
      numeroDistinta: '7809',
      dataCreazione: '2004-08-18',
      importoContanti: 1500,
      importoAssegni: 1060,
      importoTotale: 2560,
      situazione: 'Chiusa',
    },
  ],
  dettagliDistinteVersamento: [
    {
      id: 'distinta-26492',
      numeroDistinta: '26492',
      situazione: 'Lavorazione',
      dataCreazione: '2025-08-03',
      riepilogo: {
        totaleContanti: 820,
        totaleAssegni: 5820,
        totaleDistinta: 6031.87,
      },
      ricevuta: {
        numeroDistinta: '26492',
        dataConferma: '2025-08-03',
        totaleContanti: 820,
        totaleAssegni: 5820,
        totaleDistinta: 6031.87,
        situazione: 'In riconciliazione',
      },
      versamentiContanti: [
        {
          idIncasso: '116800',
          dataIncasso: '2026-07-27',
          totaleMonete: 30,
          totaleBanconote: 450,
          importoTotale: 480,
        },
        {
          idIncasso: '116801',
          dataIncasso: '2026-07-27',
          totaleMonete: 50,
          totaleBanconote: 950,
          importoTotale: 1000,
        },
        {
          idIncasso: '116802',
          dataIncasso: '2026-07-27',
          totaleMonete: 20,
          totaleBanconote: 820,
          importoTotale: 840,
        },
      ],
      assegni: [
        {
          idIncasso: '116876',
          dataIncasso: '2026-07-27',
          abi: '5387',
          cab: '76270',
          banca: 'BPER BANCA S.P.A.',
          numeroAssegno: '8006509154',
          importoTotale: 480,
        },
        {
          idIncasso: '117215',
          dataIncasso: '2026-08-03',
          abi: '8855',
          cab: '40340',
          banca: 'BANCA INTESA SAN PAOLO',
          numeroAssegno: '5500650823',
          importoTotale: 840,
        },
      ],
    },
  ],
  dettagliBrogliacci: [
    {
      id: 'brg-004',
      numeroBrogliaccio: 'BRG-004',
      situazione: 'Aperto',
      versamentiContanti: [
        {
          idIncasso: 'INC-041',
          dataIncasso: '2026-07-10',
          cliente: 'AUTOTRASPORTI ROSSI SRL',
          importoMonete: 0,
          importoBanconote: 820,
          importoTotale: 820,
        },
      ],
      assegni: [
        {
          idIncasso: 'INC-041',
          dataIncasso: '2026-07-10',
          cliente: 'AUTOTRASPORTI ROSSI SRL',
          abi: '03069',
          cab: '01000',
          banca: 'INTESA SANPAOLO',
          numeroAssegno: '0000012345',
          importo: 5820,
        },
      ],
      partiteAssociate: [
        {
          numeroDocumento: 'FT/2026/00412',
          dataDocumento: '2026-05-10',
          dataScadenza: '2026-06-09',
          totaleFattura: 6680,
          importoAssegnato: 6680,
          importoResiduo: 0,
          idIncasso: 'INC-041',
        },
      ],
      riepilogo: {
        totaleContanti: 820,
        totaleAssegni: 5820,
        totaleGenerale: 6680,
      },
    },
  ],
  incassiDaRendicontare: [
    {
      id: 'INC-041',
      zona: 'TO-01',
      cliente: 'AUTOTRASPORTI ROSSI SRL',
      dataIncasso: '2026-07-10',
      importoContanti: 0,
      importoAssegni: 4660,
      importoTotale: 4660,
      selezionato: true,
    },
    {
      id: 'INC-042',
      zona: 'TO-01',
      cliente: 'BIANCHI CARBURANTI SPA',
      dataIncasso: '2026-07-10',
      importoContanti: 820,
      importoAssegni: 0,
      importoTotale: 820,
      selezionato: true,
    },
    {
      id: 'INC-043',
      zona: 'TO-02',
      cliente: 'VERDI LOGISTICA SNC',
      dataIncasso: '2026-07-11',
      importoContanti: 0,
      importoAssegni: 1200,
      importoTotale: 1200,
      selezionato: true,
    },
  ],
  partiteDaSaldare: [
    {
      codiceCliente: '0001234567',
      idDocumento: 'FT/2026/00412',
      dataDocumento: '2026-05-10',
      dataScadenza: '2026-06-09',
      descrizione: 'Bonifico 30gg DF',
      totaleFattura: 3660.00,
      importoResiduo: 3660.00,
      statoSaldo: '',
    },
    {
      codiceCliente: '0001234567',
      idDocumento: 'FT/2026/00388',
      dataDocumento: '2026-04-22',
      dataScadenza: '2026-05-22',
      descrizione: 'Bonifico 30gg DF',
      totaleFattura: 1160.50,
      importoResiduo: 1160.50,
      statoSaldo: '',
    },
    {
      codiceCliente: '0001234567',
      idDocumento: 'FT/2026/00301',
      dataDocumento: '2026-03-15',
      dataScadenza: '2026-04-14',
      descrizione: 'RiBa 60gg',
      totaleFattura: 1200.00,
      importoResiduo: 1200.00,
      statoSaldo: '',
    },
  ],
  accontiSpese: [
    {
      codiceCliente: '0001234567',
      descrizione: 'Acconto',
      importo: 0,
    },
  ],
  ricevuta: {
    numero: 'INC-2024-00847',
    email: 'rossi@email.com',
    agente: 'Quietanze Italia',
    partitaFallback: {
      documento: 'FT-2024/001',
      descrizione: 'acconto',
      importo: 152,
    },
  },
  estrattoConto: {
    movimenti: [
      {
        dataDocumento: '2026-05-10',
        numeroDocumento: 'FT/2026/00412',
        causale: 'Fattura',
        numeroRiferimento: '412',
        dataScadenza: '2026-06-09',
        importo: 3660,
        dareAvere: 'D',
        situazione: 'Aperta',
      },
      {
        dataDocumento: '2026-04-22',
        numeroDocumento: 'FT/2026/00388',
        causale: 'Fattura',
        numeroRiferimento: '388',
        dataScadenza: '2026-05-22',
        importo: 1160.5,
        dareAvere: 'D',
        situazione: 'Aperta',
      },
      {
        dataDocumento: '2026-02-01',
        numeroDocumento: 'INC/2026/00090',
        causale: 'Incasso',
        numeroRiferimento: '90',
        dataScadenza: '',
        importo: 900,
        dareAvere: 'A',
        situazione: 'Chiusa',
      },
    ],
    documenti: [
      {
        idDocumento: 'FT-2024/001',
        totaleFattura: 2500,
        pagamenti: [
          {
            importoPagamento: 500,
            dataPagamento: '2024-11-10',
            metodoPagamento: 'Contanti',
            importoResiduo: 2000,
          },
          {
            importoPagamento: 750,
            dataPagamento: '2024-12-15',
            metodoPagamento: 'Assegno',
            importoResiduo: 1250,
          },
        ],
      },
      {
        idDocumento: 'FT-2024/023',
        totaleFattura: 3200,
        pagamenti: [
          {
            importoPagamento: 1200,
            dataPagamento: '2025-01-20',
            metodoPagamento: 'Bonifico',
            importoResiduo: 2000,
          },
          {
            importoPagamento: 1200,
            dataPagamento: '2025-02-05',
            metodoPagamento: 'Contanti',
            importoResiduo: 800,
          },
        ],
      },
      {
        idDocumento: 'FT-2024/042',
        totaleFattura: 4100,
        pagamenti: [
          {
            importoPagamento: 2050,
            dataPagamento: '2025-03-01',
            metodoPagamento: 'Assegno',
            importoResiduo: 2050,
          },
        ],
      },
    ],
    riepilogo: {
      rischio: 651.48,
      rischioAScadere: 0,
      scaduti: 651.48,
      aScadere: 0,
    },
  },
  storicoPartite: [
    {
      idDocumento: 'FT-2023/089',
      dataDocumento: '2023-01-15',
      dataScadenza: '2023-02-15',
      descrizione: 'Bonifico 30gg',
      dataChiusura: '2024-03-20',
      totaleFattura: 1500,
      importoResiduo: 0,
      situazione: 'Saldata',
    },
    {
      idDocumento: 'FT-2023/102',
      dataDocumento: '2023-03-10',
      dataScadenza: '2023-04-10',
      descrizione: 'Bonifico 60gg',
      dataChiusura: '2024-05-15',
      totaleFattura: 3800,
      importoResiduo: 0,
      situazione: 'Saldata',
    },
    {
      idDocumento: 'FT-2023/118',
      dataDocumento: '2023-05-22',
      dataScadenza: '2023-06-22',
      descrizione: 'Bonifico 30gg',
      dataChiusura: '2024-07-02',
      totaleFattura: 2200,
      importoResiduo: 0,
      situazione: 'Saldata',
    },
    {
      idDocumento: 'FT-2024/003',
      dataDocumento: '2024-01-05',
      dataScadenza: '2024-02-05',
      descrizione: 'Bonifico 30gg',
      dataChiusura: '2024-09-10',
      totaleFattura: 900,
      importoResiduo: 0,
      situazione: 'Saldata',
    },
  ],
} as const;
